import React from 'react';

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.25 5.069h-10.5c-.435 0-.788.352-.788.787v6.563c0 .435.353.787.788.787h10.5c.435 0 .787-.352.787-.787v-6.563c0-.435-.352-.787-.787-.787m-10.5-.963c-.966 0-1.75.784-1.75 1.75v6.563c0 .966.784 1.75 1.75 1.75h10.5c.966 0 1.75-.784 1.75-1.75v-6.563c0-.966-.784-1.75-1.75-1.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.063 1c.265 0 .48.215.48.481v1.313c0 .266-.215.481-.48.481-.266 0-.482-.215-.482-.481v-1.313c0-.266.216-.481.482-.481",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.938 1c.265 0 .48.215.48.481v1.313c0 .266-.215.481-.48.481-.266 0-.482-.215-.482-.481v-1.313c0-.266.216-.481.482-.481",
    clipRule: "evenodd"
  }));
};
SvgCalendar.displayName = "Calendar";

export { SvgCalendar as S };
